<template>
    <div class="text-center container"
         style="max-width: 500px;">
      <div  v-for="(item) in mainFields"
            role="group"
            class="input-group">
        <div  class="input-group-prepend">
          <div  class="input-group-text">
            {{$t('dns')[item.key]}}
          </div>
        </div>
        <input type="text"
               v-model="dnsObject[item.key]"
               :placeholder="item.required ? 'Pflichtfeld' : 'optional'"
               class="form-control" >
      </div>

      <b-button class="col-12 mt-4 mb-4"
                @click="newRecordObj.push(Object.assign({},recordObj))">
        Eintrag hinzufügen
      </b-button>

      <b-table :fields="newRecordFields" :items="newRecordObj">
        <template slot="name" slot-scope="item">
          <b-input v-model="newRecordObj[item.index]['name']">
          </b-input>
        </template>
        <template slot="type" slot-scope="item">
          <b-input v-model="newRecordObj[item.index]['type']">
          </b-input>
        </template>
        <template slot="data" slot-scope="item">
          <b-input v-model="newRecordObj[item.index]['data']">
          </b-input>
        </template>
        <template slot="ttl" slot-scope="item">
          <b-input v-model="newRecordObj[item.index]['ttl']">
          </b-input>
        </template>
        <template slot="deleterow" slot-scope="item">
          <b-link @click="newRecordObj.splice(item.index,1) "
                  variant="outline-success">
            Entfernen
          </b-link>
        </template>
      </b-table>

      <div  class="fixed-bottom footer-summary">
        <b-button class="col-12"
                  variant="primary"
                  @click="saveDns()">
          Speichern
        </b-button>
      </div>

    </div>
</template>

<script>
  import {ApiRoutesModel} from "@/store/models/layout/api_routes";
  import {NameserverZone} from "@/store/models/dns/nameserver_zone";

  export default {
        name: "luma-create-zone-dns",
        data:()=>({
            dnsObject:{},
            recordObj:{name:'',type:'',data:'',ttl:''},
            newRecordObj:[{name:'',type:'',data:'',ttl:''}],
        }),
        computed:{
            apiCreateDnsRoute(){
                return ApiRoutesModel.query().where('key','post.dns.zones.create').get()[0]
            },
            mainFields(){
                return [
                    {key:'hostmaster',required:true},
                    {key:'ns_first',required:true},
                    {key:'ns_second',required:true},
                    {key:'refresh',required:false},
                    {key:'retry',required:false},
                    {key:'expire',required:false},
                    {key:'ttl',required:false}
                ]
            },
            newRecordFields(){
                return [
                    {key:'name',label:'NAME',sortable:false},
                    {key:'type',label:'TYPE',sortable:false},
                    {key:'data',label:'DATA',sortable:false},
                    {key:'ttl',label:'TTL',sortable:false},
                    {key:'deleterow',label:'Entfernen',sortable:false}
                ]
            },
        },
        methods:{
            saveDns(){
                const x = Object.assign({},this.dnsObject,{records:this.newRecordObj})
                ApiRoutesModel.createAxios(this.apiCreateDnsRoute,x)
                    .then(response => {
                        console.log('DNS SAVED NEW RECORD??',response)
                        /// INSERT UPDATE RESPONSE
                        NameserverZone.insertOrUpdate({data:response.data.zone})
                    })
                    .catch(error => {
                            // NameserverZone.find(this.dns)
                            console.log('DNS ERRORORO',error)
                        }
                    )
            }
        }
    }
</script>

<style scoped>
  .input-group-text{
    min-width: 180px;
  }
  .footer-summary {
    margin-left: 220px;
    z-index: 1000;
    padding: 20px;
    /*height: 85px;*/
    background: white;
    box-shadow: 0 -1px 5px rgba(0,0,0,.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/dns/list_dns/luma-create-zone-dns.vue